import React from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';
import { Sizes } from '../../enums/sizes';
import { Themes } from '../../enums/themes';
import { Types } from '../../enums/types';

// INTERFACES
import { ITagProps } from '../../interfaces/Tag.interface';

// STYLES
import { Container, Label } from './styles';

const Tag: React.FC<ITagProps> = ({
  children,
  size = Sizes.BIG,
  type = Types.DEFAULT,
  color = Themes.DEFAULT
}: ITagProps) => {
  return (
    <Container size={size} color={color} type={type}>
      {type == Types.WITHICON && <Icon type={Icons.MORE} />}
      <Label size={size}>{children}</Label>
    </Container>
  );
};

export default Tag;
